import {
    SET_REMOTE_ARTICLES,
    SET_REMOTE_CATEGORIES,
    SET_TEXT_SEARCH,
    SET_CATEGORY_SEARCH,
    SET_ARTICLE_LOADER,
    SET_CATEGORY_LOADER_STATUS,
    SET_CATEGORY_ID,
    SET_ARTICLE_SEARCH_QUERY,
} from "./mutation-types";

const mutations = {
    [SET_TEXT_SEARCH](state, { textSearchQuery }) {
        state.textSearchQuery.data = textSearchQuery;
    },
    [SET_CATEGORY_SEARCH](state, { categorySearchQuery }) {
        state.categorySearchQuery.data = categorySearchQuery;
    },
    [SET_REMOTE_ARTICLES](state, { remoteData }) {
        state.remoteArticle = remoteData;
    },
    [SET_REMOTE_CATEGORIES](state, { remoteData }) {
        state.remoteCategory = remoteData;
    },
    [SET_ARTICLE_LOADER](state, { status }) {
        state.loadArticlesStatus.status = status;
    },
    [SET_CATEGORY_LOADER_STATUS](state, { status }) {
        state.loadCategoryStatus = status;
    },
    [SET_CATEGORY_ID](state, { categoryId }) {
        state.categoryId = categoryId;
    },
    [SET_ARTICLE_SEARCH_QUERY](state, { searchQuery }) {
        state.textSearchQuery = searchQuery;
    },
};

export default mutations;
